import type { WorkerNotificationType } from '../types.js'

/**
 * The heading a message card wears, by kind (the Shift Bidding Demo's
 * result cards lead with one): what sort of thing this is, in two or three
 * words, before the message itself. Product copy, like the messages.
 */
export const MESSAGE_TITLE: Record<WorkerNotificationType, string> = {
  streak_milestone: 'Streak',
  score_update: 'Score update',
  bid_window_approaching: 'Bid window',
  coaching: 'Worth working on',
  tier_within_reach: 'Next tier within reach',
  tier_at_risk: 'Tier at risk',
  recovery: 'The way back',
  improvement: 'Improving',
  custom_behavior_prompt: 'Worth logging',
  period_closing: 'Period closing',
  score_final: 'Final score',
  welcome: 'Welcome',
  barrier_reply: 'Your facility replied',
  bridge_callout: 'Bridge shift available',
  bridge_cancelled: 'Callout withdrawn',
  bridge_filled: 'Bridge shift is yours',
  bridge_covered: 'Shift covered',
  bid_result: 'Your schedule is ready',
  swap_offer: 'A swap is offered to you',
  open_shift_offer: 'An open shift for you',
  open_shifts_posted: 'Open shifts you can take',
  schedule_update: 'Your schedule changed',
  schedule_reminder: 'Your schedule needs you',
  bidding_open: 'Bidding is open',
  low_census: 'Low census: a shift released',
  recall_offer: 'Your shift is yours again if you want it',
  floated: 'Your shift moved units',
  staff_message: 'A message from your facility',
}

export function messageTitle(type: WorkerNotificationType): string {
  return MESSAGE_TITLE[type] ?? 'Message'
}
